import { type Bill, type BillVersion } from '@/types/bill'
import { cn } from "@/lib/utils"
import { Badge } from "@/components/ui/badge"
import { Loader2 } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

interface AiReviewCellProps {
  bill: Bill;
  latestVersion: BillVersion;
  loadingAction?: string;
  onClick?: () => void;
}

export function AiReviewCell({latestVersion, loadingAction, onClick }: AiReviewCellProps) {
  // Check if a review is being generated
  const isGeneratingReview = loadingAction === 'LegislativeReview';

  // Check if a review exists
  const hasReview = !!latestVersion?.legislativeReviewS3Key;

  // If no review exists and none is being generated, don't render anything
  if (!hasReview && !isGeneratingReview) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="secondary"
            className={cn(
              "cursor-pointer transition-colors",
              hasReview
                ? "bg-blue-100 hover:bg-blue-200 text-blue-800"
                : "bg-gray-100 text-gray-500"
            )}
            onClick={hasReview ? onClick : undefined}
          >
            {isGeneratingReview ? (
              <>
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
                Generating
              </>
            ) : (
              <>

                AI Review
              </>
            )}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          {isGeneratingReview
            ? "AI review is being generated..."
            : hasReview
              ? "Click to view AI legislative review"
              : "No AI review available"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}